var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-body"},[_c('div',{staticClass:"z-aside"},[_c('layout-aside',{on:{"skip":_vm.skip}})],1),_vm._v(" "),_c('div',{staticClass:"z-main"},[_c('div',{staticClass:"z-header"},[_c('layout-header')],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"20px","height":"calc(100% - 70px)","overflow":"scroll"}},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1e8da2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/layout/bms.vue
// module id = null
// module chunks = 